import { Directive, ElementRef, inject, signal, effect } from '@angular/core';

@Directive({
  selector: '[dssLibsUiAutoHideScrollbar]',
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()',
    '(scroll)': 'onScroll()',
  },
})
export class AutoHideScrollbarDirective {
  readonly #el = inject(ElementRef<HTMLElement>);

  readonly #showScrollbar = signal(false);

  constructor() {
    this.#el.nativeElement.classList.add('auto-hide-scrollbar');

    effect(() => {
      this.#el.nativeElement.classList.toggle('show-scrollbar', this.#showScrollbar());
    });
  }

  protected onMouseEnter() {
    this.#showScrollbar.set(true);
  }

  protected onMouseLeave() {
    this.#showScrollbar.set(false);
  }

  protected onScroll() {
    this.#showScrollbar.set(true);
  }
}
